<template>
  <div class="wrapper">
    <div class="twoSideBox">
      <div class="leftBox" ref="treeBox" style="width: 200px">
        <h2 class="centerFont">学习计划分类</h2>
        <div class="treeBox">
          <mytree
              :searchInput="true"
              :treeData="learnplanType"
              @eventUp="treeEvent"
              @dataUpdate="planTypeUpdate"
          ></mytree>
        </div>
      </div>
      <div class="slider" @mousedown="sliderClick"></div>
      <div class="rightBox">
        <div class="tableContainer">
          <div class="tableContent">
            <div class="actBar">
              <div>
                <el-button
                    icon="el-icon-plus"
                    size="small"
                    type="primary"
                    @click="goTo('learnPlanEdit')"
                >新建计划</el-button
                >
                <!-- <el-button type="primary" size="small" plain
                  >一周考试详情</el-button
                > -->
                <el-button
                    type="primary"
                    size="small"
                    :disabled="!paperIfSelectSome"
                    @click="examMoveData.ifShow = true"
                    plain
                >移动到分类</el-button
                >
                <el-button
                    icon="el-icon-delete-solid"
                    type="danger"
                    size="small"
                    :disabled="!paperIfSelectSome"
                    @click="deletePaperList"
                    plain
                >删除计划</el-button
                >
              </div>

              <div>
                <el-input
                    placeholder="请输入名称"
                    v-model="searchCondition.title"
                    style="width: 200px"
                    size="small">
                  <el-button
                      icon="el-icon-search"
                      slot="append"
                      @click="searchPaperByName"
                  ></el-button>
                </el-input>
              </div>
            </div>

            <div class="filterBar">
              <el-checkbox :value="paperIfSelectAll" @change="paperSelectAll"
              >全选</el-checkbox
              >
              <el-pagination
                  layout="prev, pager, next"
                  :current-page.sync="searchCondition.jumpPage"
                  @current-change="searchPaperList"
                  :total="searchCondition.total"
              >
              </el-pagination>

<!--              <div class="testStatusBar">-->
<!--                <div-->
<!--                    :class="[-->
<!--                    'testStatus',-->
<!--                    { active: searchCondition.status == '' },-->
<!--                  ]"-->
<!--                    @click="changeStatus('')"-->
<!--                >-->
<!--                  所有-->
<!--                </div>-->
<!--                <div-->
<!--                    :class="[-->
<!--                    'testStatus',-->
<!--                    { active: searchCondition.status == 4 },-->
<!--                  ]"-->
<!--                    @click="changeStatus(4)"-->
<!--                >-->
<!--                  已考完-->
<!--                </div>-->

<!--                <div-->
<!--                    :class="[-->
<!--                    'testStatus',-->
<!--                    { active: searchCondition.status == 3 },-->
<!--                  ]"-->
<!--                    @click="changeStatus(3)"-->
<!--                >-->
<!--                  考试中-->
<!--                </div>-->
<!--                <div-->
<!--                    :class="[-->
<!--                    'testStatus',-->
<!--                    { active: searchCondition.status == 2 },-->
<!--                  ]"-->
<!--                    @click="changeStatus(2)"-->
<!--                >-->
<!--                  未开始-->
<!--                </div>-->
<!--                <div-->
<!--                    :class="[-->
<!--                    'testStatus',-->
<!--                    { active: searchCondition.status == 1 },-->
<!--                  ]"-->
<!--                    @click="changeStatus(1)"-->
<!--                >-->
<!--                  草稿-->
<!--                </div>-->
<!--              </div>-->
            </div>
            <div class="contentBox">
              <div
                  class="contentBar"
                  v-for="item in learnPlanList"
                  :key="'paper' + item.id"
              >
                <el-checkbox v-model="item.choose"></el-checkbox>
                <img class="tableImg" :src="
           item.type == 1
              ? require('@/assets/img/type1.png')
              : require('@/assets/img/type2.png')
          " alt />
                <div class="detailBox">
                  <div class="titleBar" @click="showShareUrl(item)">
                    {{ item.title }}
                  </div>
                  <div style="color: #2d8cf0">成长计划</div>
                  <div class="settingBar">
                   总结段数：共{{item.round}}个阶段 | 含 {{item.catalog || 0}}个测试
                  </div>
                  <div class="settingBar">
                    {{item.userName}} 创建于{{item.createTime}} 上次更新：{{item.updateTime}}
                    <div class="actBar">
                      <el-button
                          size="mini"
                          @click="goTo('learnPlanEdit', item, 'learnPlanEdit')"
                      >设置</el-button
                      >
                      <el-button
                          size="mini"
                          @click="goTo('paperAnalysis', item, 'paperAnalysis')"
                      >详情</el-button
                      >
                      <el-button
                          size="mini"
                          @click="goTo('paperDataEdit', item, 'examinationEdit')"
                      >学习记录</el-button
                      >
                      <el-button
                          size="mini"
                          @click="goTo('recordList', item, 'recordList')"
                      >分享</el-button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        title="请选择试卷分类"
        :visible.sync="examMoveData.ifShow"
        width="50%"
        :append-to-body="true"
    >
      <mytree :treeData="learnplanType" @eventUp="examGroupEvent"></mytree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="examMoveData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="examGroupConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="选择时间"
        :visible.sync="paperOpenSetIfShow"
        width="50%"
        :append-to-body="true"
    >
      <el-radio v-model="paperOpenSet.validDateSet" :label="2"
      >永久有效</el-radio
      ><br /><br />
      <el-radio v-model="paperOpenSet.validDateSet" :label="1"
      >限时开放<br />
        <el-date-picker
            @change="
            (changeData) =>
              ([paperOpenSet.startTime, paperOpenSet.endTime] = changeData)
          "
            size="mini"
            v-model="paperOpenSet.upToDate"
            v-show="paperOpenSet.validDateSet == 1"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="paperOpenSetIfShow = false">取 消</el-button>
        <el-button type="primary" @click="editPaperOpenSet">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
        :title="shareItem.exName"
        :visible.sync="shareItemIfShow"
        width="70%"
        :append-to-body="true"
    >
      <div class="shareBox">
        <div class="shareContent">
          <div class="title">方式一：复制链接考试</div>
          <el-input disabled v-model="shareExamUrl" class="urlInput"></el-input>
          <div class="midFont" v-if="shareItem.accessCode">
            访问码：{{ shareItem.accessCode }}
          </div>
          <div class="actBar">
            <el-button type="primary" size="mini" @click="copyText"
            >复制链接</el-button
            >
            <el-button type="primary" size="mini" @click="jumpTo" plain
            >直接打开</el-button
            >
          </div>
        </div>
        <div class="shareContent">
          <div class="title">方式二：二维码分享</div>
          <!-- <el-input disabled v-model="shareExamUrl"></el-input> -->
          <div class="centerFont bigFont">{{ shareItem.exName }}</div>
          <vue-qr
              :text="shareExamUrl"
              id="qrcodeImg"
              ref="qrcodeImg"
              style="display: block; margin: auto"
          ></vue-qr>
          <div class="greyFont centerFont">把二维码分享给您的学生</div>

          <div class="actBar">
            <el-button type="primary" size="mini" @click="downloadQrcode"
            >下载二维码</el-button
            >
          </div>
        </div>
        <!-- <div class="shareContent">
          <div class="title">方式三：小程序分享</div>
          <el-input disabled v-model="shareItem.url"></el-input>
          <div class="greyFont">把小程序二维码分享给您的学生</div>
          <div class="actBar">
            <el-button type="primary" size="mini">下载二维码</el-button>
          </div>
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selectTreeData,editPlanGroup,delPlanGroup,planPageList
} from "@/api/learnplan.js";
import vueQr from "vue-qr";
import { Base64 } from "@/libs/js/base64.js";

import mytree from "@/component/tree/mytree.vue";
export default {
  components: { mytree, vueQr },
  props: {},
  data() {
    return {
      learnPlanList: [],
      split1: 0.2,
      shareItemIfShow: false,
      shareItem: "",
      total: {
        examinationCount: 0,
        testCount: 0,
        classification: 0,
        archive: 0,
      },
      searchCondition: {
        groupId: 0,
        status: "",
        pageSize: 10,
        jumpPage: 1,
        total: 0,
        title: "",
      },
      learnplanType: [],
      buttonProps: {
        type: "default",
        size: "small",
      },
      single: false,
      paperOpenSetIfShow: false,
      paperOpenSet: {
        startTime: "",
        endTime: "",
        validDateSet: "",
        upToDate: "",
      },
      examMoveData: {
        ifShow: false,
        chosenGroupId: 0,
      },
      examGroupChooseIfShow: false,

      consituteList: ["固定", "随机", "固定+随机"],
      Base64: new Base64(),
    };
  },
  watch: {},
  computed: {
    paperIfSelectAll() {
      return this.learnPlanList.every((item) => item.choose);
    },
    paperIfSelectSome() {
      return this.learnPlanList.some((item) => item.choose);
    },
    shareExamUrl() {
      let query = this.Base64.encode(`examId-${this.shareItem.id}`);
      let host = "testxk.cbstudy.com/exam";
      // document.location.host.indexOf("test") > -1
      //   ? "testxk.cbstudy.com/exam"
      //   : "exam.cbstudy.com";
      return `https://${host}/#/?${query}`;

      // return `https:///#/?${query}`;
    },
  },
  methods: {
    pageInit(){
      planPageList(this.searchCondition).then((data) => {
           this.learnPlanList = data.data.rows;
           console.log("请求列表", this.learnPlanList);
      });
    },
    examGroupEdit() {},
    examGroupEvent(eventDetail, data) {
      switch (eventDetail.type) {
        case "rename":
          renameExaminationType({
            id: eventDetail.contextData.id,
            parentId: eventDetail.contextData.parentId,
            newName: eventDetail.value,
          }).then(
              (data) => {
                this.$Message.success("修改成功");
                this.questionTypeInit();
              },
              (data) => {
                this.$Message.error(data || "错误");
              }
          );

          break;
        case "delete":
          deleteExaminationType({
            id: eventDetail.value,
          }).then(
              (data) => {
                this.$Message.success("删除成功");
                this.questionTypeInit();
              },
              (data) => {
                this.$Message.error(data || "错误");
              }
          );
          break;
        case "append":
          appendExaminationType({
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
              (data) => {
                this.$Message.success("创建成功");
                this.questionTypeInit();
              },
              (data) => {
                this.$Message.success(data || "创建失败");
              }
          );
          break;
        case "move":
          moveExaminationType({
            id: eventDetail.id,
            newParentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
              (data) => {
                this.$Message.success("移动成功");
                this.questionTypeInit();
              },
              (data) => {
                this.$Message.success(data || "移动失败");
              }
          );
          break;
        case "select":
          this.examMoveData.chosenGroupId = eventDetail.value.id;
          // console.log(eventDetail);
          break;
        default:
          break;
      }
    },
    planTypeUpdate(newExaminationTypeUpdate) {
      this.$set(this.$data, "learnplanType", newExaminationTypeUpdate);
    },
    examGroupConfirm() {
      movePaperGroup({
        newGroupId: this.examMoveData.chosenGroupId,
        idList: this.learnPlanList
            .filter((paper) => paper.choose)
            .map((item) => item.id),
      }).then((data) => {
        this.$message.success("移动成功");
        this.examMoveData.ifShow = false;
        this.searchPaperList();
      });
    },
    treeEvent(eventDetail, data) {
      console.log(eventDetail, data);
      switch (eventDetail.type) {
        case "select":
          if (eventDetail.value.id !== this.searchCondition.groupId) {
            this.searchCondition.jumpPage = 1;
            this.searchCondition.groupId = eventDetail.value.id;
            this.searchPaperList();
          }
          break;
        case "rename":
          editPlanGroup({
            id: eventDetail.contextData.id,
            parentId: eventDetail.contextData.parentId,
            title: eventDetail.value,
          }).then(
              (data) => {
                this.$Message.success("修改成功");
                this.learnPlanTypeInit();
              },
              (data) => {
                this.$Message.error(data || "错误");
              }
          );
          break;
        case "delete":
          delPlanGroup({
            ids: eventDetail.value,
          }).then(
              (data) => {
                this.$Message.success("删除成功");
                this.learnPlanTypeInit();
              },
              (data) => {
                this.$Message.error(data || "错误");
              }
          );
          break;
        case "append":
          editPlanGroup({
            parentId: eventDetail.parentId,
            title: eventDetail.title,
          }).then(
              (data) => {
                this.$Message.success("创建成功");
                this.learnPlanTypeInit();
              },
              (data) => {
                this.$Message.success(data || "创建失败");
              }
          );
          break;
        case "move":
          editPlanGroup({
            id: eventDetail.id,
            ParentId: eventDetail.parentId,
            title: eventDetail.title,
          }).then(
              (data) => {
                this.$Message.success("移动成功");
                this.learnPlanTypeInit();
              },
              (data) => {
                this.$Message.success(data || "移动失败");
              }
          );
          break;
        default:
          break;
      }
    },

    paperStatusEdit(item) {
      switch (item.status) {
        case 1:
          paperStatusEdit({ examId: item.id, isRelease: true }).then(
              (data) => {
                this.$message.success("发布成功");
                this.searchPaperList();
              },
              (err) => {
                this.$message.error(err);
              }
          );
          break;
        case 3:
          paperStatusEdit({ examId: item.id, validDateSet: 3 }).then(
              (data) => {
                this.$message.success("停止成功");
                this.searchPaperList();
              },
              (err) => {
                this.$message.error(err);
              }
          );
          break;

        case 2:
          Object.assign(this.paperOpenSet, {
            examId: item.id,
            upToDate: [item.startTime, item.endTime],
            startTime: item.startTime,
            endTime: item.endTime,
            validDateSet: item.validDateSet,
          });
          this.paperOpenSetIfShow = true;
          break;
        case 4:
          Object.assign(this.paperOpenSet, {
            examId: item.id,
            upToDate: [item.startTime, item.endTime],
            startTime: item.startTime,
            endTime: item.endTime,
            validDateSet: item.validDateSet,
          });
          this.paperOpenSetIfShow = true;
          break;
        default:
          break;
      }
    },
    editPaperOpenSet() {
      paperStatusEdit(this.paperOpenSet).then((data) => {
        this.$message.success("修改成功");
        this.searchPaperList();
        this.paperOpenSetIfShow = false;
      });
    },
    showShareUrl(item) {
      console.log(item);
      this.shareItem = item;
      this.shareItemIfShow = true;
    },

    //分类初始化
    learnPlanTypeInit() {
      selectTreeData().then((data) => {
        data.data.forEach(function treeMaker(item) {
          item.expand = false;
          item.contextmenu = true;
          if (item.children && item.children.length > 0) {
            item.children.forEach((nextItem) => treeMaker(nextItem));
          }
        });
        data.data.unshift({
          id: 0,
          title: "所有分类",
          parentId: 0,
          children: [],
        });
        this.learnplanType = data.data;
      });
    },
    searchPaperList() {
      planPageList(this.searchCondition).then((data) => {
        console.log("返回的",data);
        if (!Array.isArray(data.data.rows)) {
          data.data.rows = [];
        }
        data.data.rows.forEach((item) => (item.choose = false));
        this.learnPlanList = data.data.rows;
        this.searchCondition.total = data.data.total;
        Object.assign(this.total, data);
      });
    },
    searchPaperByName() {
      console.log(this.searchCondition);
      this.searchCondition.jumpPage = 1;
      this.searchPaperList();
    },
    topPaper(item) {
      editPaper({ examId: item.id, top: item.top ? 0 : 1 }).then((data) => {
        console.log(data);
        this.$message.success(item.top ? "取消" : "" + "置顶成功");
        this.searchPaperList();
      });
    },
    miniappEdit(item, value) {
      editPaper({ examId: item.id, appletShow: value }).then((data) => {
        this.$message.success(value ? "小程序显示成功" : "小程序隐藏成功");
        this.searchPaperList();
      });
    },
    deletePaperList() {
      let deleteList = this.learnPlanList.filter((item) => item.choose);
      if (deleteList.length == 0) {
        return;
      }
      this.$confirm(
          "此操作将删除" + deleteList.length + "张试卷, 是否继续?",
          "删除确认",
          {
            confirmButtonText: "删除",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
      ).then(() => {
        deletePaperList({
          ids: deleteList.map((item) => item.id).toString(),
        }).then(() => {
          this.searchPaperList();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
      });
    },
    changeStatus(status) {
      if (status == this.searchCondition.status) {
        return;
      }
      Object.assign(this.searchCondition, { status: status, jumpPage: 1 });
      this.searchPaperList();
    },
    paperSelectAll(data) {
      if (this.learnPlanList.some((item) => item.choose)) {
        this.learnPlanList.forEach((item) => (item.choose = false));
      } else {
        this.learnPlanList.forEach((item) => (item.choose = true));
      }
    },
    downloadQrcode: function (imgsrc, name) {
      var image = new Image();

      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = () => {
        let fontLimitPerLine = parseInt((image.width + 100) / 24);
        let exNameList = [...this.shareItem.exName],
            textList = [],
            perText = [],
            textLength = 0;
        exNameList.forEach((item) => {
          if (item.charCodeAt > 255) {
            textLength += 2;
          } else {
            textLength++;
          }
          perText.push(item);
          if (textLength >= fontLimitPerLine) {
            textList.push(perText.join(""));
            perText = [];
            textLength = 0;
          }
        });
        textList.push(perText.join(""));
        //试卷名分割

        var canvas = document.createElement("canvas");
        canvas.width = image.width + 100;
        canvas.height = image.height + 32 * (textList.length + 2);
        var context = canvas.getContext("2d");

        context.font = " 24px Arial";
        context.textBaseline = "middle";
        context.textAlign = "center";
        context.fillStyle = "#000";

        textList.forEach((item, index) => {
          context.fillText(item, canvas.width / 2, index * 32 + 20);
        });

        console.log(this.shareItem.exName.length, canvas.width);
        context.fillText(
            `访问码：${this.shareItem.accessCode}`,
            canvas.width / 2,
            (textList.length + 1) * 32
        );
        context.drawImage(
            image,
            50,
            (textList.length + 2) * 32,
            image.width,
            image.height
        ); //image.width, image.height

        var url = canvas.toDataURL(); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || new Date().getTime(); // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      // image.src = document.getElementById("qrcodeImg").src;
      image.src = this.$refs.qrcodeImg.$el.src;
    },
    copyText() {
      console.log(this.shareExamUrl);
      var input = document.createElement("input");
      if (this.shareItem.accessCode) {
        input.value =
            this.shareExamUrl + "  访问码：" + this.shareItem.accessCode;
      } else {
        input.value = this.shareExamUrl;
      }
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },
    jumpTo() {
      window.open(this.shareExamUrl, "_blank");
    },
    sliderClick(event) {
      let widthReduce = document.body.scrollWidth * 0.135;
      let widthMin = widthReduce + 150;
      document.onmousemove = (event) => {
        if (event.screenX > widthMin) {
          this.$refs.treeBox.style.width = event.screenX - widthReduce + "px";
        }
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
  },
  created() {},
  mounted() {
    this.learnPlanTypeInit();
    this.pageInit();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  // min-width: 1000px;
  // background: #fff;
  font-size: 12px;
  // margin: 15px;
  .twoSideBox {
    display: flex;
    position: relative;
    // max-height: 80vh;
    margin-top: 10px;
    .leftBox {
      padding-top: 5px;
      // width: 200px;
      background: #fff;
    }
    .slider {
      width: 8px;
      background: rgba(0, 0, 0, 0.1);
      cursor: w-resize;
    }
    .rightBox::-webkit-scrollbar {
      display: none;
    }
    .rightBox {
      flex: 1;
      // padding: 0 15px;
      min-height: 30vh;
      //   max-height: 80vh;
      overflow: scroll;

      .tableContainer {
        border: 1px solid #ccc;
        border-radius: 0 5px 5px 0;

        .tableTitle {
          color: #000;
          font-weight: bold;
          font-size: 1.4rem;
          padding-left: 10px;
          border-bottom: 1px solid #ccc;
          padding: 10px;
          background: #fff;
          border-radius: 0 5px 0 0;
        }
        .tableContent {
          padding: 10px;
          background: #fff;
          border-radius: 0 0 5px 0;
          .actBar {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .filterBar {
            display: flex;
            height: 40px;
            align-items: center;
            justify-content: space-between;
            .testStatusBar {
              display: flex;

              .testStatus {
                padding: 3px 8px;
                line-height: 20px;
                border: 1px solid #ccc;
                margin-left: -1px;
                min-width: 50px;
                text-align: center;
              }

              .testStatus:hover {
                opacity: 0.8;
              }
              .active {
                border-color: #618afd;
                color: #618afd;
                z-index: 1;
              }
              .testStatus:first-child {
                border-radius: 13px 0 0 13px;
              }
              .testStatus:last-child {
                border-radius: 0 13px 13px 0;
              }
            }
          }
          .contentBox {
            border: 1px solid #ccc;
            padding: 20px;

            .contentBar {
              display: flex;
              align-items: center;
              justify-content: space-between;
              flex: 1;
              margin-bottom: 20px;
              // border-bottom: 1px solid #ccc;
              border: 1px solid #ccc;
              padding: 40px 10px;
              border-radius: 4px;
              .el-checkbox {
                margin-right: 10px;
              }
              .tableImg {
                width: 25%;

              }
              .detailBox {
                flex: 1;
                margin-left: 20px;
                .titleBar {
                  font-size: 1.6rem;
                  font-weight: bold;
                  display: flex;
                  cursor: pointer;
                  align-items: center;
                  .label {
                    font-weight: normal;
                    font-size: 13px;
                    color: #fff;
                    background: red;
                    padding: 0px 7px;
                    margin: 0 10px;
                    border-radius: 9px !important;
                    vertical-align: top;
                    display: inline-block;
                    cursor: pointer;
                  }
                }
                .settingBar {
                  margin-bottom: 1rem;
                }
              }
              .actBar {
                justify-content: flex-end;
              }
            }
          }
        }
      }
    }
  }
  .navBar {
    display: flex;
    padding: 15px;
    justify-content: space-between;
    background: #fff;
    .navBox {
      display: flex;
      font-size: 1.5rem;
      border-radius: 10px;
      height: 95px;
      width: 22%;
      color: #fff;
      align-items: center;
      justify-content: center;
      i {
        font-size: 2rem;
      }
    }
    .navBox:nth-child(1) {
      background: #63b5ef;
    }
    .navBox:nth-child(2) {
      background: #92cb7b;
    }
    .navBox:nth-child(3) {
      background: #efd07c;
    }
    .navBox:nth-child(4) {
      background: #ec8472;
    }
  }
}
.shareBox {
  display: flex;
  justify-content: space-around;
  background: #f6f8ff;
  padding: 20px 10px;
  .shareContent {
    background: #fff;
    padding: 10px 10px 60px 10px;
    margin: 0 10px;
    flex: 1;
    position: relative;
    .title {
      font-size: 1.05rem;
    }
    .urlInput {
      display: block;
      width: 100%;
    }
    .actBar {
      position: absolute;
      text-align: center;
      bottom: 20px;
      width: 100%;
      left: 0;
    }
    .qrcode {
      width: 170px;
      height: 170px;
      display: block;
      margin: 15px auto;
    }
    .downloadBtn {
    }
  }
}
/deep/ .el-button + .el-button {
  margin-left: 5px;
}
/deep/ .el-checkbox__inner {
  height: 20px;
  width: 20px;
}
/deep/ .el-checkbox__inner::after {
  width: 4px;
  height: 12px;
  left: 6px;
  top: 0;
  border-width: 2px;
}
</style>